import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
export function StormPrepCTA() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 3000], [0, -150]);
  const checklist = ['Get ahead of storm season', 'Protect your home', 'Work with professionals you can trust'];
  return <section className="relative w-full py-20 md:py-32 overflow-hidden" data-id="element-107">
      <motion.div style={{
      y
    }} className="absolute inset-0" data-id="element-108">
        <img src="https://cdn.magicpatterns.com/uploads/o7NgPAJewD3uZym15X2cH8/kyan-tijhuis-JNxi-VoQPo8-unsplash.jpg" alt="Tree canopy overhead" className="w-full h-full object-cover" data-id="element-109" />
        <div className="absolute inset-0" style={{
        backgroundColor: 'rgba(0,0,0,0.78)'
      }} data-id="element-110" />
      </motion.div>

      <div className="relative z-10 container mx-auto px-6 text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-112">
          <h2 className="font-display text-3xl md:text-5xl text-white mb-6" style={{
          textShadow: '0 2px 12px rgba(0,0,0,0.9)'
        }} data-id="element-113">
            Don't Wait Until It Causes Damage.
          </h2>
          <p className="font-body text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-8" style={{
          textShadow: '0 1px 8px rgba(0,0,0,0.85)'
        }} data-id="element-114">
            We're currently in the Valley getting properties storm-ready. We
            only take a limited number of jobs, get ahead of the rush.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-10" data-id="element-115">
            {checklist.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-2 text-white font-body" style={{
            textShadow: '0 1px 8px rgba(0,0,0,0.85)'
          }} data-id="element-116">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-117" />
                <span data-id="element-118">{item}</span>
              </motion.div>)}
          </div>

          <Button className="bg-brand-orange hover:bg-brand-orange/90 text-white font-body font-bold text-lg h-14 px-10 mb-4 w-full sm:w-auto min-h-[48px]" data-id="element-119">
            Book Your Free Estimate
          </Button>
          <p className="font-body text-white/80" data-id="element-120">
            Or call Rigo directly:{' '}
            <a href="tel:6025525252" className="text-brand-green hover:underline font-semibold" data-id="element-121">
              602-552-5252
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}